import { useEffect, useState } from 'react';

const configCache = {
  data: null,
  promise: null,
};

export const fetchConfig = async () => {
  const response = await fetch('/options-config.json', { cache: 'no-cache' });
  if (!response.ok) {
    throw new Error('Failed to load options config');
  }
  return response.json();
};

const useOptionConfig = () => {
  const [config, setConfig] = useState(configCache.data);

  useEffect(() => {
    if (configCache.data) {
      setConfig(configCache.data);
      return;
    }

    if (!configCache.promise) {
      configCache.promise = fetchConfig().then((data) => {
        configCache.data = data;
        return data;
      });
    }

    configCache.promise
      .then((data) => setConfig(data))
      .catch(() => setConfig({ defaultOptions: [], meta: { error: true } }));
  }, []);

  return {
    config: config || {},
    defaultOptions: config?.defaultOptions || [],
    loading: !config && !configCache.data,
  };
};

export default useOptionConfig;
